import ContentfulInternationalSizeConversionGuide from '@src/quince-site-common/src/domains/contentful/contentful-international-size-conversion-guide'
import {
  ContentfulSizeChart,
  ContentfulSizeChartSection,
} from '@src/quince-site-common/src/domains/contentful/ContentfulProduct'

const getSortedSizeChartSections = (
  sections: ContentfulSizeChartSection[] | undefined,
): ContentfulSizeChartSection[] => {
  if (!sections?.length) return []

  const defaultIndex = sections.findIndex(section => section?.isDefault === true)
  if (defaultIndex <= 0) return sections

  const defaultSection = sections[defaultIndex]
  if (!defaultSection) return sections

  return [defaultSection, ...sections.slice(0, defaultIndex), ...sections.slice(defaultIndex + 1)]
}

export const normalizeSizeChartDefaultUnitOrder = (
  sizeChart: ContentfulSizeChart | ContentfulInternationalSizeConversionGuide | undefined | null,
  enabled = false,
): ContentfulSizeChart | ContentfulInternationalSizeConversionGuide | undefined => {
  if (!sizeChart) return undefined
  if (!enabled) return sizeChart

  return {
    ...sizeChart,
    sections: getSortedSizeChartSections(sizeChart.sections),
  }
}

// Single source of truth for the size-chart default-unit selection rule.
// Any size-guide variant (V1, V2, future) MUST go through this helper so
// Contentful's `isDefault` flag is honoured consistently for locales that
// opt into localised size-guide defaults via `displayLocalisedReviewSize`.
export const getDefaultSizeChartUnitIndex = (
  sections: ContentfulSizeChartSection[] | undefined | null,
  enabled = false,
): number => {
  if (!enabled || !sections?.length) return 0
  const defaultIndex = sections.findIndex(section => section?.isDefault === true)
  return defaultIndex >= 0 ? defaultIndex : 0
}
